var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { assert } from '../../babylon/utility/Assert.js';
import { Bound } from './Bound.js';
const DEFAULT = {
    frames_to_start: 4,
    frames_to_end: 4,
    debounce_time: 150
};
const MINIMUM = {
    frames_to_start: 1,
    frames_to_end: 0,
    debounce_time: 0
};
/**
 * Debounce handler that relies on frame count using the `update_observer`.
 */
export class DebounceHandler {
    constructor(viewer, on_start, on_end, _frames_to_start = DEFAULT.frames_to_start, _frames_to_end = DEFAULT.frames_to_end, _debounce_time = DEFAULT.debounce_time) {
        this.on_start = on_start;
        this.on_end = on_end;
        this._frames_to_start = _frames_to_start;
        this._frames_to_end = _frames_to_end;
        this._debounce_time = _debounce_time;
        this._was_called = false;
        this._is_sequential = false;
        this._frames_to_start_count = 0;
        this._frames_to_end_count = 0;
        this._stored_debounce_call = null;
        this._debounce_timer = null;
        this._frames_to_start = Math.max(Math.round(this._frames_to_start), MINIMUM.frames_to_start);
        this._frames_to_end = Math.max(Math.round(this._frames_to_end), MINIMUM.frames_to_end);
        this._debounce_time = Math.max(Math.round(this._debounce_time), MINIMUM.debounce_time);
        this._update_observer = viewer.get_update_observable().add(() => {
            if (!this._was_called) {
                this._is_sequential = false;
                this.handle_sequence_end();
            }
            else {
                this._is_sequential = true;
                this._was_called = false;
            }
        });
    }
    call(sender, value) {
        this._frames_to_end_count = 0;
        if (this._debounce_timer) {
            clearTimeout(this._debounce_timer);
            this._debounce_timer = null;
        }
        if (this._is_sequential) {
            this._frames_to_start_count++;
        }
        else if (!this._stored_debounce_call) {
            this._frames_to_start_count = 0;
        }
        this._was_called = true;
        if (this._frames_to_start_count === this._frames_to_start) {
            this.on_start(sender, value);
        }
        if (this._frames_to_start_count >= this._frames_to_start) {
            this._stored_debounce_call = {
                sender: sender,
                value: value
            };
        }
    }
    dispose() {
        this._update_observer.dispose();
    }
    handle_sequence_end() {
        if (!this._stored_debounce_call)
            return;
        if (this._frames_to_end_count >= this._frames_to_end) {
            if (this._debounce_time === 0) {
                this.end_sequence();
            }
            else if (!this._debounce_timer) {
                this._debounce_timer = setTimeout(this.end_sequence, this._debounce_time);
            }
        }
        else {
            this._frames_to_end_count++;
        }
    }
    end_sequence() {
        assert(this._stored_debounce_call, 'No stored debounce call');
        this.on_end(this._stored_debounce_call.sender, this._stored_debounce_call.value);
        this._stored_debounce_call = null;
        if (this._debounce_timer) {
            clearTimeout(this._debounce_timer);
            this._debounce_timer = null;
        }
    }
}
__decorate([
    Bound
], DebounceHandler.prototype, "end_sequence", null);
//# sourceMappingURL=DebounceHandler.js.map